import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LanguageState = {
  langcode: 'de' | 'en' | string;
};

const initialState: LanguageState = {
  langcode: 'de',
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageState['langcode']>) => {
      state.langcode = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
